import React, { useState, useEffect } from 'react';
import stockReorderApi, { errorMessage } from '../../../api/stockReorderApi';
import SupplierMapCard from './SupplierMapCard';

/**
 * Which supplier each part comes from — per branch.
 *
 * Split from the supplier *rules* screen because the two share nothing but the
 * word "supplier": this is branch-scoped and runs to tens of thousands of rows,
 * rules are global and number a couple of dozen.
 */

const TEMPLATE_CSV =
    'sep=,\r\nPart Number,Supplier Name\r\n10007,ALI BIN ALI & PARTNERS (GENERAL)\r\n';

const downloadTemplate = () => {
    // The BOM keeps Excel from mangling non-ASCII supplier names on open.
    const blob = new Blob(['﻿' + TEMPLATE_CSV], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'supplier_mapping_template.csv';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

const SupplierMappingTab = ({ onToast }) => {
    const [units, setUnits] = useState([]);
    const [businessUnitId, setBusinessUnitId] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        stockReorderApi
            .listAllBusinessUnits()
            .then((d) => {
                const list = d.business_units || [];
                setUnits(list);
                setBusinessUnitId((current) => current || list[0]?.id || '');
            })
            .catch((err) => setError(errorMessage(err, 'Could not load branches')));
    }, []);

    const branchName = units.find((u) => u.id === businessUnitId)?.name || '';

    return (
        <div className="sr-stack">
            <section className="sr-card">
                <h2 className="sr-card-title">Supplier mapping</h2>
                <p className="sr-hint">
                    Which supplier each part number belongs to. Held per branch, and read every
                    time a reorder sheet is generated.
                </p>

                <div className="sr-field">
                    <label htmlFor="sr-map-bu">Configure branch</label>
                    <select
                        id="sr-map-bu"
                        value={businessUnitId}
                        onChange={(e) => setBusinessUnitId(e.target.value)}
                    >
                        <option value="">Select a branch…</option>
                        {units.map((bu) => (
                            <option key={bu.id} value={bu.id}>
                                {bu.name}
                            </option>
                        ))}
                    </select>
                    <span className="sr-hint">
                        Separate from the working branch on Reorder Sheet — configuration is often
                        done for a branch other than the one you are buying for.
                    </span>
                </div>

                <div className="sr-actions">
                    <button className="sr-btn" onClick={downloadTemplate}>
                        Download CSV template
                    </button>
                </div>

                {error && <div className="sr-alert sr-alert-error">{error}</div>}
            </section>

            <SupplierMapCard
                businessUnitId={businessUnitId}
                branchName={branchName}
                onToast={onToast}
            />
        </div>
    );
};

export default SupplierMappingTab;
